import React from 'react';

const ResendIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    id='Layer_1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={24}
    height={24}
    viewBox='0 0 512 512'
    xmlSpace='preserve'
    {...props}
  >
    <g>
      <g>
        <path d='M505.265,162.41L347.727,24.564c-5.809-5.081-14.06-6.282-21.091-3.111c-7.05,3.19-11.559,10.201-11.559,17.92v19.692 H19.692C8.802,59.065,0,67.887,0,78.757v393.846c0,10.89,8.802,19.692,19.692,19.692h393.846c10.89,0,19.692-8.802,19.692-19.692 V255.082l72.034-63.035c4.293-3.742,6.735-9.137,6.735-14.828C512,171.548,509.558,166.152,505.265,162.41z M393.846,452.911 H39.385V98.45h275.692v4.825c-44.741,14.159-171.697,66.895-177.211,211.042c-0.394,9.689,6.361,18.215,15.892,20.086 c1.26,0.256,2.54,0.354,3.801,0.354c8.133,0,15.616-5.061,18.471-12.958c19.909-54.725,101.77-64.177,139.047-65.634v58.9 c0,7.739,4.51,14.75,11.559,17.94c2.304,1.063,4.766,1.457,7.227,1.556c0.315,0.02,0.591,0.197,0.906,0.197 c0.394,0,0.768-0.177,1.142-0.197c1.477-0.099,2.875-0.374,4.293-0.768c0.67-0.197,1.339-0.335,1.969-0.591 c1.989-0.807,3.899-1.851,5.553-3.308l46.119-40.35V452.911z' fill="var(--color-action-default)" />
      </g>
    </g>
  </svg>
);

export default ResendIcon;